import { dataSyringesSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSyringesSolid = /*#__PURE__*/createIcon(dataSyringesSolid)
export default IconSyringesSolid
